import React from 'react';
import { EyeIcon, RefreshCwIcon, AlertCircleIcon } from 'lucide-react';
export function CampaignList() {
  const campaigns = [{
    name: 'GGL_XUV400',
    product: 'XUV400',
    platform: 'Google',
    status: 'Active',
    budget: '0',
    spends: '0',
    leads: '0',
    cpl: '0'
  }, {
    name: 'MET_Thar Roxx',
    product: 'Thar Roxx',
    platform: 'Facebook',
    status: 'Active',
    budget: '0',
    spends: '0',
    leads: '---',
    cpl: '---'
  }, {
    name: 'GGL_Thar',
    product: 'Thar',
    platform: 'Google',
    status: 'Active',
    budget: '0',
    spends: '0',
    leads: '0',
    cpl: '0'
  }, {
    name: 'GGL_Scorpio-N',
    product: 'Scorpio-N',
    platform: 'Google',
    status: 'Active',
    budget: '0',
    spends: '0',
    leads: '0',
    cpl: '0'
  }, {
    name: 'MET_BE6_EV',
    product: 'BE6 EV',
    platform: 'Facebook',
    status: 'Active',
    budget: '0',
    spends: '0',
    leads: '---',
    cpl: '---'
  }, {
    name: 'MET_BE9_EV',
    product: 'BE9 EV',
    platform: 'Facebook',
    status: 'Active',
    budget: '0',
    spends: '0',
    leads: '---',
    cpl: '---'
  }, {
    name: 'GGL_Bolero',
    product: 'Bolero',
    platform: 'Google',
    status: 'Active',
    budget: '0',
    spends: '0',
    leads: '0',
    cpl: '0'
  }];
  return <div data-id="element-379">
      <h3 className="text-xl font-medium text-gray-800 mb-4" data-id="element-380">Campaigns List</h3>

      <div className="overflow-x-auto" data-id="element-381">
        <table className="min-w-full border-collapse" data-id="element-382">
          <thead data-id="element-383">
            <tr className="bg-blue-50" data-id="element-384">
              <th className="text-left p-3 text-sm font-medium text-blue-500" data-id="element-385">
                CAMPAIGN NAME
              </th>
              <th className="text-left p-3 text-sm font-medium text-blue-500" data-id="element-386">
                PRODUCT
              </th>
              <th className="text-left p-3 text-sm font-medium text-blue-500" data-id="element-387">
                PLATFORM
              </th>
              <th className="text-left p-3 text-sm font-medium text-blue-500" data-id="element-388">
                STATUS
              </th>
              <th className="text-left p-3 text-sm font-medium text-blue-500" data-id="element-389">
                BUDGET
              </th>
              <th className="text-left p-3 text-sm font-medium text-blue-500" data-id="element-390">
                SPENDS
              </th>
              <th className="text-left p-3 text-sm font-medium text-blue-500" data-id="element-391">
                LEADS
              </th>
              <th className="text-left p-3 text-sm font-medium text-blue-500" data-id="element-392">
                CPL
              </th>
              <th className="text-left p-3 text-sm font-medium text-blue-500" data-id="element-393">
                ACTIONS
              </th>
            </tr>
          </thead>
          <tbody data-id="element-394">
            {campaigns.map((campaign, index) => <tr key={index} className="border-b border-gray-200" data-id="element-395">
                <td className="p-3 text-sm text-gray-700" data-id="element-396">{campaign.name}</td>
                <td className="p-3 text-sm text-gray-700" data-id="element-397">
                  {campaign.product}
                </td>
                <td className="p-3 text-sm text-gray-700" data-id="element-398">
                  {campaign.platform === 'Google' ? <div className="flex items-center" data-id="element-399">
                      <GoogleIcon data-id="element-400" />
                      <span className="ml-2" data-id="element-401">Google</span>
                    </div> : <div className="flex items-center" data-id="element-402">
                      <FacebookIcon data-id="element-403" />
                      <span className="ml-2" data-id="element-404">Facebook</span>
                    </div>}
                </td>
                <td className="p-3 text-sm" data-id="element-405">
                  <span className="text-green-500" data-id="element-406">{campaign.status}</span>
                </td>
                <td className="p-3 text-sm text-gray-700" data-id="element-407">{campaign.budget}</td>
                <td className="p-3 text-sm text-gray-700" data-id="element-408">{campaign.spends}</td>
                <td className="p-3 text-sm text-gray-700" data-id="element-409">{campaign.leads}</td>
                <td className="p-3 text-sm text-gray-700" data-id="element-410">{campaign.cpl}</td>
                <td className="p-3 text-sm" data-id="element-411">
                  <div className="flex items-center" data-id="element-412">
                    <button className="text-blue-500 bg-white rounded-md border border-gray-200 px-3 py-1 text-xs mr-2" data-id="element-413">
                      TOP-UP
                    </button>
                    <AlertCircleIcon size={16} className="text-red-500 mr-2" data-id="element-414" />
                    <EyeIcon size={16} className="text-gray-400 mr-2" data-id="element-415" />
                    <RefreshCwIcon size={16} className="text-gray-400" data-id="element-416" />
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}
function GoogleIcon() {
  return <div className="flex items-center justify-center rounded-full w-6 h-6 bg-blue-50" data-id="element-417">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-418">
        <path d="M22.5 12.5c0-1.58-.875-2.95-2.148-3.6.154-.435.238-.905.238-1.4 0-2.21-1.71-3.998-3.818-3.998-.47 0-.92.084-1.336.25C14.818 2.415 13.51 1.5 12 1.5s-2.816.917-3.437 2.25c-.415-.165-.866-.25-1.336-.25-2.11 0-3.818 1.79-3.818 4 0 .494.083.964.237 1.4-1.272.65-2.147 2.018-2.147 3.6 0 1.495.782 2.798 1.942 3.486-.02.17-.032.34-.032.514 0 2.21 1.708 4 3.818 4 .47 0 .92-.086 1.335-.25.62 1.334 1.926 2.25 3.437 2.25 1.512 0 2.818-.916 3.437-2.25.415.163.865.248 1.336.248 2.11 0 3.818-1.79 3.818-4 0-.174-.012-.344-.033-.513 1.158-.687 1.943-1.99 1.943-3.484z" fill="#4285F4" data-id="element-419" />
      </svg>
    </div>;
}
function FacebookIcon() {
  return <div className="flex items-center justify-center rounded-full w-6 h-6 bg-blue-50" data-id="element-420">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-421">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" fill="#1877F2" data-id="element-422" />
      </svg>
    </div>;
}